import * as React from 'react';
import { Link } from 'react-router-dom';
// import { UserInfo } from './components/UserInfo';
// import { LanguageMenu } from './components/LanguageMenu';
import styles from './index.module.less';
import { Dropdown } from 'm-ui';
// import logoImg from 'assets/img/logo.svg';
// import NavigationMenu from './components/NavigationMenu';
import { FormattedMessage } from 'react-intl';
import InspirationOverlay from './components/InspirationOverlay';
import TrendingOverlay from './components/TrendingOverlay';
import HelpCenter from './components/HelpCenter';
import LanguageOverlay from './components/LanguageOverlay';
import { paths } from 'constants/paths';
import { LanguageType } from 'types/enum';
import { useLocale } from 'locales/I18N';
import LogoImg from 'assets/img/logo.png';
import { ucJump, System } from '@i18n/kwai-i18n-ad-jump-fe';
// import { url } from '@i18n/uc';
import { useGetWebAccountInfoUsingPOST } from 'query/webAccount';
import avatarImg from 'assets/img/avatart.png';
import { logCustom } from 'logger/logger';
import { LOG_IN_HEADER } from 'logger/eventType';
import px2vw from 'utils/px2vw';

export const LanguageOptions = [
    {
        key: LanguageType.zhCN,
        value: '中文',
        alias: '中文',
    },
    {
        key: LanguageType.enUS,
        value: 'En',
        alias: 'EN',
    },
];

export const Header: React.FC<{}> = () => {
    const { locale, setLocale } = useLocale();
    const language = LanguageOptions.find((item) => item.key === locale)?.value;
    // const accountInfo = useAccountInfo();
    // const userData = accountInfo?.data?.data;
    // const userData = {accountId: 1}
    const { data: userInfo, isLoading } = useGetWebAccountInfoUsingPOST();
    return (
        <header className={styles.header} id="observe_header">
            <div className={styles.left}>
                <div className={styles.icon}>
                    <Link to="/" style={{ marginTop: px2vw(-4) }}>
                        <img src={LogoImg} alt="" />
                    </Link>
                </div>
                <Dropdown
                    overlayClassName={styles.dropdown}
                    overlay={<InspirationOverlay />}
                    getPopupContainer={(trigger) => trigger}
                    placement="bottomCenter"
                    // visible
                >
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="Inspiration" />
                    </div>
                </Dropdown>
                <Dropdown
                    overlayClassName={styles.dropdown}
                    overlay={<TrendingOverlay />}
                    getPopupContainer={(trigger) => trigger}
                    placement="bottomCenter"
                    // visible
                >
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="Trends" />
                    </div>
                </Dropdown>
                {/* <Link to={paths.TRENDING.path}>
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="趋势" />
                    </div>
                </Link> */}
                {/* <Link to={paths.CRETIVETOOL.path}>
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="Creative Tools" />
                    </div>
                </Link> */}
                {/* <Link to={paths.ExcitingVideo.path}>
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="热门视频" />
                    </div>
                </Link> */}
                {/* <Link to={paths.CREATIVEPURCHASING.path}>
                    <div className={styles.listItemWrapper}>
                    <FormattedMessage defaultMessage="Creative purchase" />
                    </div>
                </Link> */}
                <Link to={paths.CREATIVEPURCHASING.path}>
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="Purchase of Creatives" />
                    </div>
                </Link>
                {/* {!isLoading && (
                    <div
                        className={styles.listItemWrapper}
                        onClick={() =>
                            platformJump.goToHome({
                                accountId: userInfo?.accountId ?? '', // 可否作为可选  如果不传递，获取header或者url上面的字段？
                                providerId: userInfo?.providerId ?? '', // 可否作为可选  如果不传递，获取header或者url上面的字段？
                                fromCrm: url.getFromCrm(),
                                _blank: true,
                            })
                        }
                    >
                        <FormattedMessage defaultMessage="Purchase of Creatives" />
                    </div>
                )} */}
                {/* <NavigationMenu /> */}
            </div>
            <div className={styles.right}>
                <Dropdown
                    overlayClassName={styles.dropdown}
                    overlay={<HelpCenter />}
                    getPopupContainer={(trigger) => trigger}
                    placement="bottomCenter"
                    // visible
                >
                    {/* <Link to='/overlay'> */}
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="Help" />
                    </div>
                    {/* </Link> */}
                </Dropdown>
                <Dropdown
                    overlayClassName={styles.dropdown}
                    overlay={<LanguageOverlay locale={locale} setLocale={setLocale} />}
                    getPopupContainer={(trigger) => trigger}
                    placement="bottomCenter"
                    // visible
                >
                    <div className={styles.listItemWrapper}>
                        <FormattedMessage defaultMessage="{language}" values={{ language }} />
                    </div>
                </Dropdown>
                <div className={styles.logInfo}>
                    {!isLoading && (
                        <>
                            {userInfo?.isLogin ? (
                                <div
                                    className={styles.user}
                                    onClick={() => {
                                        window.location.hash = paths.PERSONAL.path;
                                    }}
                                >
                                    <img src={avatarImg} alt="" />
                                </div>
                            ) : (
                                <div
                                    className={styles.signUp}
                                    onClick={() => {
                                        logCustom(LOG_IN_HEADER);
                                        ucJump.goToLogin({
                                            targetServer: System.creativePortal,
                                            followUrl: window.location.href,
                                        });
                                    }}
                                >
                                    <FormattedMessage defaultMessage="Log In" />
                                </div>
                            )}
                        </>
                    )}
                </div>
                {/* <Dropdown
                    overlayClassName={styles.dropdown}
                    overlay={<HelpCenter />}
                    // visible
                >
                    <Link to='/overlay'>
                        <div className={styles.listItemWrapper}>
                            <FormattedMessage defaultMessage="联系" />
                        </div>
                    </Link>
                </Dropdown> */}
                {/* <LanguageMenu /> */}
                {/* <Divider type="vertical" />
                <UserInfo /> */}
            </div>
        </header>
    );
};
